import script from "./Clock.vue?vue&type=script&setup=true&lang=ts"
export * from "./Clock.vue?vue&type=script&setup=true&lang=ts"

import "./Clock.vue?vue&type=style&index=0&id=171c4b44&lang=sass"

const __exports__ = script;

export default __exports__